module.exports = __webpack_public_path__ + "static/media/no-photo.2296124b.svg";